<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-logo">
        <span class="logo-text">xiaoyang</span>
      </div>
      <div class="footer-links">
        <router-link to="/">首页</router-link>
        <router-link to="/docs">文档</router-link>
        <router-link to="/project">开源项目</router-link>
      </div>
      <div class="footer-social">
        <a href="https://github.com/UR-xiaoyang" target="_blank" class="social-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>
        </a>
        <a href="https://space.bilibili.com/98621956" target="_blank" class="social-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><path d="M17 2l-5 5-5-5"></path></svg>
        </a>
      </div>
    </div>
    <div class="copyright">
      <p>&copy; 2025 ur-xiaoyang.com 版权所有</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'EndnoteGroup'
}
</script>

<style scoped>
.footer {
  margin-top: 60px;
  padding: 40px 20px 20px;
  background: rgba(20, 20, 20, 0.8);
  backdrop-filter: blur(10px);
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #42b983, transparent);
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-logo {
  margin-bottom: 15px;
}

.logo-text {
  font-size: 1.8rem;
  font-weight: 700;
  color: #42b983;
  letter-spacing: 1px;
}

.footer-links {
  display: flex;
  gap: 20px;
  margin: 15px 0;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.footer-links a:hover {
  color: #42b983;
  transform: translateY(-2px);
}

.footer-social {
  display: flex;
  gap: 15px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transition: all 0.3s ease;
}

.social-icon:hover {
  background: #42b983;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(66, 185, 131, 0.3);
}

.copyright {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-links {
    margin: 20px 0;
  }
}
</style>